<template>
  <v-dialog persistent v-model="dialog" width="840px">
    <v-card>
      <v-card-title>
        <span class="headline"> 选择对象 </span>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>
              {{ $t("$vuetify.close") }}
            </span>
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-8 text-center subtitle-1">
        <v-container>
          <v-form>
            <v-row>
              <!-- obj_type：1要货商  2供应商 -->
              <v-col cols="12" sm="6" md="6">
                <SearcherObjType v-model="objType" />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                v-if="objType == 1"
              >
                <SearcherKeyword
                  ref="shop_name"
                  v-model="options.shop_name"
                  @text="shopNameKeyword = $event"
                  :label="$t('paymentBat.obj.shop_name', [$consts.shopName()])"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                v-if="objType == 1"
              >
                <SearcherKeyword
                  ref="shop_code"
                  v-model="options.shop_code"
                  @text="shopCodeKeyword = $event"
                  :label="$t('paymentBat.obj.shop_code', [$consts.shopName()])"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                v-if="objType == 1"
              >
                <SearcherKeyword
                  ref="shop_user_name"
                  v-model="options.shop_user_name"
                  @text="shopUserNameKeyword = $event"
                  :label="$t('paymentBat.obj.shop_user_name', [$consts.shopName()])"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                v-if="objType == 1"
              >
                <SearcherKeyword
                  ref="login_user_id"
                  v-model="options.login_user_id"
                  @text="shopUserIdKeyword = $event"
                  :label="$t('paymentBat.obj.shop_consumer', [$consts.shopName()])"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                v-if="objType == 1"
              >
                <SearcherDistrict v-model="districtSelected" />
              </v-col>

              <v-col
                cols="12"
                sm="6"
                md="6"
                v-if="objType == 2"
              >
                <SearcherKeyword
                  ref="supplier_name"
                  v-model="options.supplier_name"
                  @text="supplierNameKeyword = $event"
                  :label="$t('paymentBat.obj.supplier_name')"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                v-if="objType == 2"
              >
                <SearcherKeyword
                  ref="supplier_code"
                  v-model="options.supplier_code"
                  @text="supplierCodeKeyword = $event"
                  :label="$t('paymentBat.obj.supplier_code')"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                v-if="objType == 2"
              >
                <SearcherKeyword
                  ref="supplier_user_name"
                  v-model="options.supplier_user_name"
                  @text="supplierUserNameKeyword = $event"
                  :label="$t('paymentBat.obj.supplier_user_name')"
                />
              </v-col>
            </v-row>
          </v-form>
          <v-btn color="info" @click.stop="search()">搜索</v-btn>
          <div class="mx-4 mb-4">
            <v-data-table
              :headers="shopsHeaders"
              :items="shops"
              :options.sync="options"
              :loading="loading"
              :page.sync="paging.page"
              :server-items-length="paging.count"
              multi-sort
              class="elevation-1 px-4 pt-1"
              :footer-props="$t('$config.footer-props')"
            >
              <template v-slot:header.actions>
                <v-checkbox
                  class="mt-2 mb-n3"
                  color="primary"
                  :indeterminate="shops.find((detail) => detail.check != checkAll) ? true : false"
                  v-model="checkAll"
                >
                  <template v-slot:label>
                    <span class="caption ms-n2">
                      {{ $t("paymentBat.obj.Fields.check_all") }}
                    </span>
                  </template>
                </v-checkbox>
              </template>
              <template v-slot:item.actions="{ item }">
                <!--                  <v-btn color="primary" @click.stop="shopsSelect(item)"-->
                <!--                    >选择</v-btn-->
                <!--                  >-->
                <div class="d-flex mt-n2 mb-n3">
                  <v-checkbox
                    color="primary"
                    v-model="item.check"
                    :true-value="1"
                    :false-value="0"
                  >
                  </v-checkbox>
                </div>
              </template>
            </v-data-table>
          </div>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined @click="dialog = false">{{ $t("$vuetify.close") }}</v-btn>
        <v-btn
          color="accent"
          @click="returnObjIds()"
        >
          {{$t("CRUD.confirmWithChooseCount", [checkedObj.length ? checkedObj.length : 0,]) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Shops from "@/api/shops";
import Suppliers from "@/api/suppliers";
import SearcherDistrict from "@/components/plugins/SearcherDistrict";
import SearcherObjType from "@/components/plugins/SearcherObjType";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";

export default {
  name: "DialogObjs",

  components: {
    SearcherDistrict,
    SearcherObjType,
    SearcherKeyword,
  },

  props: {
    value: Boolean,
    shopSelectedObj: Array,
    shopSelected: Array,
    objOptions: Object,
  },

  computed: {
    shopsHeaders() {
      var shopsHeaders = [];
      if (this.objType == 1) {
        shopsHeaders.push(
          {
            text: i18n.t("paymentBat.obj.Fields.shop_name"),
            align: "start",
            sortable: false,
            value: "shop_name",
          },
          {
            text: i18n.t("paymentBat.obj.Fields.shop_code"),
            align: "start",
            sortable: false,
            value: "shop_code",
          },
          {
            text: i18n.t("paymentBat.obj.Fields.district"),
            align: "start",
            sortable: false,
            value: "district.name",
          },
          {
            text: i18n.t("TableHeaders.actions"),
            align: "start",
            sortable: false,
            value: "actions",
          }
        );
      } else {
        shopsHeaders.push(
          {
            text: i18n.t("paymentBat.obj.Fields.supplier_name"),
            align: "start",
            sortable: false,
            value: "supplier_name",
          },
          {
            text: i18n.t("paymentBat.obj.Fields.supplier_code"),
            align: "start",
            sortable: false,
            value: "supplier_code",
          },
          {
            text: i18n.t("paymentBat.obj.Fields.district"),
            align: "start",
            sortable: false,
            value: "district.name",
          },
          {
            text: i18n.t("TableHeaders.actions"),
            align: "start",
            sortable: false,
            value: "actions",
          }
        );
      }
      return shopsHeaders;
    },

    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    filter: "",
    shops: [],
    paging: {},
    objType: 1,
    itemsPerPageOptions: 10,
    checkAll: 0,
    checked: [],
    checkedObj: [],
    districtSelected: null,
    options: {},
    shopNameKeyword: "",
    shopCodeKeyword: "",
    shopUserNameKeyword: "",
    shopUserIdKeyword: "",
    supplierNameKeyword: "",
    supplierCodeKeyword: "",
    supplierUserNameKeyword: "",

  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
        if (this.dialog) {
          // 每次打开对话框重置查询
          this.checked = this.shopSelected;
          this.checkedObj = this.shopSelectedObj;
          this.getDataFromAPI();
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) this.shops = [];
      },
    },
    checkAll: {
      handler() {
        this.shops = this.shops.map(
          function (detail) {
            detail.check = this.checkAll ? 1 : 0;
            return detail;
          }.bind(this)
        );
      },
    },
    objOptions: {
      immediate: true, //初始赋值也调用
      deep: true,
      handler() {
        if (this.objOptions) {
          this.options = this.objOptions;
          this.objType = this.objOptions.obj_type;
          this.districtSelected = null
        }
      },
    },
    options:{
      deep: true,
      handler() {
        this.getDataFromAPI();
      }
    },
    shops: {
      deep: true,
      handler() {
        this.shops.forEach((shop) => {
          if (shop.check) {
            if (this.checked.findIndex((item) => item  == shop.id) == -1){
              this.checked.push(shop.id)
              this.checkedObj.push(shop)
            }
          }else {
            if (this.checked.findIndex((item) => item  == shop.id) != -1){
              this.checked.splice(this.checked.findIndex((item) => item  == shop.id), 1)
              this.checkedObj.splice(this.checkedObj.findIndex((item) => item.id  == shop.id), 1)
            }
          }
        })
      }
    },
    districtSelected: {
      handler() {
        this.options.district_id = this.districtSelected ? this.districtSelected.id : "";
      },
    },
    objType: {
      handler() {
        this.shopNameKeyword = "";
        this.shopCodeKeyword = "";
        this.shopUserNameKeyword = "";
        this.shopUserIdKeyword = "";
        this.supplierNameKeyword = "";
        this.supplierCodeKeyword = "";
        this.supplierUserNameKeyword = "";
        this.options = {
          obj_type: 1,
          shop_name: "",
          shop_code: "",
          shop_user_name: "",
          login_user_id: "",
          supplier_name: "",
          supplier_code: "",
          supplier_user_name: "",
          district_id: "",
        }
        this.districtSelected = null
        this.options.obj_type = this.objType;
        this.checked = [];
        this.checkedObj = [];
        this.checkAll = 0;
      }
    }
  },

  methods: {
    getDataFromAPI() {
      if (this.objType == 1) {
        this.getShopsFromAPI();
      } else {
        this.getSupplierFromAPI();
      }
    },
    resizeHeader() {
      this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    },

    search() {
      this.options = Object.assign({}, this.options, {
        shop_name: this.shopNameKeyword,
        shop_code: this.shopCodeKeyword,
        shop_user_name: this.shopUserNameKeyword,
        login_user_id: this.shopUserIdKeyword,
        supplier_name: this.supplierNameKeyword,
        supplier_code: this.supplierCodeKeyword,
        supplier_user_name: this.supplierUserNameKeyword,
      });
      if (this.objType == 1) {
        this.getShopsFromAPI();
      } else {
        this.getSupplierFromAPI();
      }
    },
    getShopsFromAPI() {
      Shops.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.paging = response.data.paging;
            this.shops = response.data.shops.map((shop) => {
              if (this.checked.findIndex((item) => item  == shop.id) != -1){
                shop.check = 1;
              } else {
                shop.check = 0;
              }
              return shop;
            });
          }
        }.bind(this)
      );
    },
    getSupplierFromAPI() {
      //   this.id = this.$route.query.stock_id;
      Suppliers.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.paging = response.data.paging;
            this.shops = response.data.suppliers.map((shop) => {
              if (this.checked.findIndex((item) => item  == shop.id) != -1){
                shop.check = 1;
              } else {
                shop.check = 0;
              }
              return shop;
            });
          }
        }.bind(this)
      );
    },
    returnObjIds() {
      let selectedObj = [];
      let selectedIds = [];
      this.checkedObj.forEach((shop)=>{
        if (shop.check) {
          selectedObj.push(shop)
          selectedIds.push(shop.id)
        }
      });
      this.$emit('selectedObj', selectedObj);
      this.$emit('selectedIds', selectedIds)
      this.$emit('objOptions', this.options);
      this.dialog = false
    }
  },
};
</script>
